import { Component, OnInit, Input, ViewChild, TemplateRef, Output, EventEmitter } from '@angular/core';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import { CatalogosSatService } from '../../../../services/catalogos-sat-service';
import { VentasService } from '../../../../services/ventas.service';
import { HelpersService } from '../../../../services/tools/helpers.service';
import { Router } from '@angular/router';
import { ConstantsService } from '../../../../services/constants.service';
import { CuentasPorCobrarService } from '../../../../services/cuentas-por-cobrar.service';

@Component({
  selector: 'app-modal-confirmar-servicio',
  templateUrl: './modal-confirmar-servicio.component.html',
  styleUrls: ['./modal-confirmar-servicio.component.scss']
})
export class ModalConfirmarServicioComponent implements OnInit {
    @ViewChild('content') private content: TemplateRef<any>;

    //Const
    public static readonly TIPO_FACTURACION_DEFAULT: string = 'INMEDIATA';

    public modal: any = null;
    public cuentasPorPagar: any [] = [];

    public facturarParcial: boolean = false;
    public tipoFacturacion: string = 'AHORA';

    //Modelos
    public factura: any = {};
    public cliente: any = {};
    public metodosPago: any[] = [];
    public formasPago: any[] = [];
    public venta: any = {};
    public usosCFDI: any[] = [];

    //Helpers
    public formaPagoSeleccionado: any = {};
    public metodoPagoSeleccionado: any = {};
    public loadingFormasPago: boolean=false;
    public errors: any = {};
    public creandoVenta: boolean=false;
    public api_url: any = '';
    public usoCFDISeleccionado: any = {};
    public loadingUsosCFDI: boolean=false;

    constructor(private modalService: NgbModal,
        private satService: CatalogosSatService,
        private ventasService: VentasService,
        private helpersService: HelpersService,
        private router: Router,
        private constant: ConstantsService) { 
          this.api_url= this.constant.apiURL;
        }

    ngOnInit() {
      
    }

    public openModal(venta: any) {
        this.venta = venta;
        this.venta.tipo_facturacion = ModalConfirmarServicioComponent.TIPO_FACTURACION_DEFAULT;
        this.modal = this.modalService.open(this.content, { size: 'lg' });
        this.cargarMetodosPago();
        this.cargarFormasPago();
        this.cargarUsosCFDI(venta.uso_cfdi);
    }

    public closeModal() {
        this.modal.close();
    }

    private cargarMetodosPago(){
        let arregloMetodosPago = [
          { id: 'PPD', descripcion: 'PPD - Pago en parcialidades'},
          { id: 'PUE', descripcion: 'PUE - Pago en una sola exhibición'}
        ];
    
        this.metodosPago = arregloMetodosPago;
        
        let component = this;
        //Si la venta esta en modo edición
        if(this.venta.venta_id){
          this.metodosPago.some(metodo => {
            if(metodo.id == component.venta.metodo_pago){
              component.seleccionarMetodoPago(metodo);
              return true;    
            }
            return false;
          });
        }else{
          //Selección default
          this.seleccionaMetodoPagoDefault();
        }
    }

    private seleccionaMetodoPagoDefault(){
      let component = this;
      this.metodosPago.some(metodo => {
        if(metodo.id === CuentasPorCobrarService.METODO_PAGO_DEFAULT_VENTA){
          component.metodoPagoSeleccionado = metodo;
          return true;
        }
        return false;
      });
    }

    private cargarFormasPago(){
        this.loadingFormasPago = true;
    
        this.satService.obtenerFormasPago()
        .subscribe(
          (response)=>{
            let formasPago = response.json().content;
            this.formasPago = formasPago;
    
            //Seleccionar la forma de pago default o la seleccionada anteriormente en caso de ser una venta en modo edición
            let component = this;
            
            formasPago.some(function(formaPago) {
              if((component.venta.id_venta && formaPago.codigo === component.venta.forma_pago) ||
              (!component.venta.id_venta && formaPago.codigo === CuentasPorCobrarService.FORMA_PAGO_DEFAULT)){
                //Si es modo edición seleccionar la forma de pago anterior y si no seleccionar la forma default
                component.seleccionarFormaPago(formaPago);
                return true;
              }
              
              return false;
            }); 
            
            this.loadingFormasPago = false;
          },
          (error)=>{
            this.loadingFormasPago = false;
            alert("ERROR:: "+JSON.stringify(error));
          }
        );
    }

    public seleccionarMetodoPago(event){
        this.metodoPagoSeleccionado = event;
        this.venta.metodo_pago = event.id;
    }

    public seleccionarFormaPago(event){
        this.formaPagoSeleccionado = event;
        this.venta.forma_pago = event.codigo;
    }

    public guardar(){
      //TODO Agregar las validaciones
      if(this.venta.id_venta){
        //Actualizar
        this.actualizarVenta(this.venta);
      }else{
        //Crear
        this.crearVenta(this.venta);
      }
    }

    private crearVenta(venta){
        this.creandoVenta = true;
        this.ventasService.crear(venta).subscribe(
          (response)=>
          {
            this.creandoVenta = false;
            this.helpersService.notification('Venta creada', 'Se ha registrado exitosamente la venta', 'success');
            const result = response.json().content;
            
            if(result.cuentas && result.cuentas.length > 0){
              let cuenta = result.cuentas[0];
              let pdfFacturalUrl = `${this.api_url}${cuenta.factura_pdf}`;
              //Abrir la factura en otra pestaña
              window.open(pdfFacturalUrl, "_blank");
            }

            this.closeModal();
            this.router.navigate(['/ventas']);
          }, error =>
          {
            this.creandoVenta = false;
            // se resuelve error 403 y 500
            this.helpersService.httpGlobalError(error);
            if(error.status == 400) {
              alert("ERROR: "+JSON.stringify(error));
            }
          }
        );
    }

    private actualizarVenta(venta){
      this.creandoVenta = true;
      this.ventasService.actualizar(venta).subscribe(
        (response)=>
        {
          this.creandoVenta = false;
          this.helpersService.notification('Venta actualizada', 'Se ha actualizado exitosamente la venta', 'success');
          const result = response.json().content;
          
          if(result.cuentas && result.cuentas.length > 0){
            let cuenta = result.cuentas[0];
            let pdfFacturalUrl = `${this.api_url}${cuenta.factura_pdf}`;
            //Abrir la factura en otra pestaña
            window.open(pdfFacturalUrl, "_blank");
          }

          this.closeModal();
          this.router.navigate(['/ventas']);
        }, error =>
        {
          this.creandoVenta = false;
          // se resuelve error 403 y 500
          this.helpersService.httpGlobalError(error);
          if(error.status == 400) {
            alert("ERROR: "+JSON.stringify(error));
          }
        }
      );
    }

    public seleccionarUsoCFDI($event){
      this.usoCFDISeleccionado = $event;
      this.venta.uso_cfdi = this.usoCFDISeleccionado.codigo;
    }

    private cargarUsosCFDI(usoCFDIDefault: string){

      this.loadingUsosCFDI = true;
      this.satService.obtenerUsosCFDI().subscribe(
        (response) => {
          let usosCFDI = response.json().content;

          this.loadingUsosCFDI = false;
          this.usosCFDI = usosCFDI;
          this.seleccionarUsoCFDIDefault(usoCFDIDefault);
        },
        error =>
          {
            this.creandoVenta = false;
            // se resuelve error 403 y 500
            this.helpersService.httpGlobalError(error);
            if(error.status == 400) {
              alert("ERROR: "+JSON.stringify(error));
            }
          }
      );
    }
    
    private seleccionarUsoCFDIDefault(usoCFDIDefault: string){
      //Si la cuenta no tiene definido un uso del cfdi utilizamos el default
      usoCFDIDefault = usoCFDIDefault ? usoCFDIDefault : CuentasPorCobrarService.USO_CFDI_DEFAULT;
  
      let component = this;
      this.usosCFDI.some(usoDelCFDI => {
        if(usoDelCFDI.codigo === usoCFDIDefault){
          component.usoCFDISeleccionado = usoDelCFDI;
          return true;
        }
        return false;
      });
    }
}


// WEBPACK FOOTER //
// ./src/app/components/modulo-servicios/formulario-servicio-general/modal-confirmar-servicio/modal-confirmar-servicio.component.ts